"use strict";
exports.__esModule = true;
exports.RoomHelper = void 0;
var lodash_1 = require("lodash");
var room_interface_1 = require("./room.interface");
var core_1 = require("../../../core");
var getDefaultOccupancy = function (room) {
    return room.occupancies.find(function (occ) { return !!occ.isDefault; });
};
/**
 * Returns the desired occupancy. or fallsback to default if none provided.
 * @param room
 * @param occId
 */
var getOccupancy = function (room, occId) {
    return Object.values(room.occupancies).find(function (occ) { return "" + occ.occupancyId === "" + occId; });
};
var getCheapestRate = function (room) {
    if (!room.rates) {
        return {};
    }
    var indexOfMin = 0;
    for (var i = 1; i < room.rates.length; i++) {
        var amountToCompare = function (index) { return room.rates[index].price.totalPrice.original.value.amount; };
        if (amountToCompare(indexOfMin) > amountToCompare(i)) {
            indexOfMin = i;
        }
    }
    return room.rates[indexOfMin];
};
var getCheapestPriceFormatted = function (room) {
    return getCheapestPrice(room).text;
};
var getCheapestPriceValue = function (room) {
    return getCheapestPrice(room).value;
};
var getCheapestPrice = function (room) {
    return lodash_1.get(getCheapestRate(room), 'price.totalPrice.converted', {});
};
var getCheapestCrossedOutPriceFormatted = function (room) {
    return getCheapestCrossedOutPrice(room).text;
};
var getCheapestCrossedOutPrice = function (room) {
    return lodash_1.get(getCheapestRate(room), 'price.crossedOutPrice.converted', {});
};
var getAvailabilityByRate = function (rate) {
    return (rate && rate.availableQuantity) || 0;
};
var getAvailabilityForCheapestRate = function (room) {
    return getAvailabilityByRate(getCheapestRate(room));
};
var getCoverImage = function (room) {
    if (room.pictures.length) {
        return room.pictures[0].templates.find(function (t) { return t.name === room_interface_1.RoomTemplateImage.Original; });
    }
    return {};
};
var getCarouselImages = function (room) {
    if (room.pictures.length) {
        var roomTemplates = room.pictures.map(function (r) { return r.templates; });
        return roomTemplates.map(function (t) { return t.find(function (t) { return t.name === room_interface_1.RoomTemplateImage.Original; }); });
    }
    return [];
};
var getSummary = function (room) {
    return room.summary.find(function (s) {
        if (s.value === room_interface_1.RoomSummaryType.Html) {
            return s;
        }
        else if (s.value === room_interface_1.RoomSummaryType.PlainText) {
            return s;
        }
        return;
    });
};
var getRoomBedsFormatted = function (room) {
    var bedDescriptions = room.bedding.beds.map(function (bed) { return bed.count + " x " + bed.type.text; });
    return bedDescriptions.reduce(function (acc, bedDesc, index) {
        if (index === bedDescriptions.length - 1) {
            return acc + bedDesc;
        }
        return acc + bedDesc + ' ' + core_1.Language.getTranslation('or') + ' ';
    }, '');
};
exports.RoomHelper = {
    getDefaultOccupancy: getDefaultOccupancy,
    getOccupancy: getOccupancy,
    getCheapestRate: getCheapestRate,
    getCheapestPrice: getCheapestPrice,
    getCheapestPriceFormatted: getCheapestPriceFormatted,
    getCoverImage: getCoverImage,
    getCarouselImages: getCarouselImages,
    getAvailabilityForCheapestRate: getAvailabilityForCheapestRate,
    getSummary: getSummary,
    getCheapestCrossedOutPrice: getCheapestCrossedOutPrice,
    getCheapestCrossedOutPriceFormatted: getCheapestCrossedOutPriceFormatted,
    getRoomBedsFormatted: getRoomBedsFormatted,
    getCheapestPriceValue: getCheapestPriceValue
};
//# sourceMappingURL=room.helper.js.map